// extracted by mini-css-extract-plugin
export default {"statusCell":"StatusCell_statusCell__jFk8M","iconButtonDownload":"StatusCell_iconButtonDownload__mGE8h"};